module.exports = __webpack_public_path__ + "img/logo_ekinet.c5aff662.jpg";